<template>
  <div class="mx-auto mb-10 sm:px-2 lg:px-4">
    <div class="text-center pb-6">
      <router-link
        :to="{
          name: 'wizard',
          params: {
            site: questionsConfig.name
          }
        }"
        class="rounded bg-primary p-2 text-white"
      >
        ← Zurück zu den Suchkriterien
      </router-link>
    </div>
    <h3
      class="mt-2 text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl sm:leading-10 text-primary text-center"
      v-if="programs.length < 1"
    >
      Keine Ergebnisse
    </h3>
    <div v-else class="bg-white shadow overflow-hidden sm:rounded-md">
      <h3
        class="mt-2 p-4 text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl sm:leading-10 text-primary text-center"
      >
        Förderprogramme ({{ programs.length }} Suchergebnisse)
      </h3>
      <div class="flex-wrap flex items-center mb-6">
        <span
          v-for="tag in selectionTags"
          :key="tag.key"
          class="px-2 py-1 ml-3 mt-3 rounded-t-full rounded-l-full border-4 border-secondary bg-secondary text-sm text-white max-w-xs lg:max-w-md focus:outline-none"
        >
          {{ tag.title }}
        </span>
      </div>
      <!-- <div class="flex h-16 pb-6 flex-row-reverse">
        <a
          v-if="!pdf.downloading && pdf.blob"
          :href="downloadUrl"
          target="_blank"
          title="Download"
          class="ui-link mr-5"
        >
          <div class="p-2 text-primary flex">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              ></path>
            </svg>
            <span class="pl-2">Download PDF</span>
          </div>
        </a>
      </div> -->
      <ul>
        <ListItem
          v-for="program in programs"
          :key="program.id"
          class="bg-gray-100 border-b border-gray-200"
          :program="program"
        ></ListItem>
      </ul>
    </div>
  </div>
</template>

<script>
import { get, sync, call } from 'vuex-pathify'
import ListItem from '@/components/Programs/ListItem'

export default {
  name: 'ProgramList',
  components: { ListItem },
  computed: {
    programs: get('programs/filtered'),
    showPrograms: sync('programs/show'),
    selection: get('programs/selection'),
    questionsConfig: get('questions/config'),
    allOptions: get('questions/allOptions'),
    pdf: get('programs/pdf'),
    selectionTags() {
      const tags = []
      Object.values(this.selection)
        .flat()
        .forEach((s) => {
          const label = this.allOptions.find((o) => o.key === s)
          if (label) tags.push(label)
        })
      return tags
    },
    downloadUrl() {
      return this.pdf.blob
        ? (window.webkitURL || window.URL).createObjectURL(this.pdf.blob)
        : '#'
    }
  },
  methods: {
    downloadPDF: call('programs/fetchPDFSearchResult')
  },
  async mounted() {
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }

    // disabled for now #12155
    // await this.downloadPDF()
  }
}
</script>

<style lang="scss" scoped></style>
